import {IState} from "@/interfaces/IState";
import {IPdf} from "@/interfaces/pdf/IPdf";
import axios from "axios";

const instance = axios.create({
    baseURL: process.env.VUE_APP_ROMA_PDF
})
const baseUrl = process.env.VUE_APP_ROMA_PDF;

export const pdf = {
    state: {
        pdf: '',
        zoom: 100,
        openSurveys: false,
        loadedPdf: false,
        alert: {
            status: '',
            text: ''
        },
        openAlert: false
    },
    mutations: {
        PDF_ZOOM(state: IState, payload: IPdf){
            state.zoom = payload.zoom;
        },
        OPEN_SURVEYS(state: IState, payload: IPdf) {
            state.openSurveys = payload.openSurveys;
        },
        LOADED_PDF(state: IState, payload: IPdf) {
            state.loadedPdf = payload.loadedPdf;
        },
        SET_PDF(state: IState, payload: any) {
            state.pdf = payload;
        },
        SET_ALERT(state: IState, payload: any) {
            state.alert = payload;
        },
        SET_OPEN_ALERT(state: IState, payload: any) {
            state.openAlert = payload;
        },
    },
    actions: {
        setZoom(context: any, payload: IPdf) {
            context.commit("PDF_ZOOM", payload);
        },
        setOpenSurveys(context: any, payload: IPdf) {
            context.commit("OPEN_SURVEYS", payload);
        },
        setLoadedPdf(context: any, payload: IPdf) {
            context.commit("LOADED_PDF", payload);
        },
        setPdf(context: any, payload: IPdf) {
            context.commit("SET_PDF", payload);
        },
        async fetchPdf(context: any, payload: any) {
            context.commit("SET_OPEN_ALERT", false);
            context.commit("SET_LOADING", true);
            const { idMedicion, idForm } = payload;
            // return await axios.get(`${baseUrl}/${idMedicion}/${idForm} 18574`)
            return await instance.get(`/${idMedicion}/${idForm}`,{
                responseType: 'blob'
            })
                .then((res) => {
                    try {
                        context.commit("SET_LOADING", false);
                        let base64data = null;
                        const reader = new FileReader();
                        reader.readAsDataURL(res.data);
                        reader.onloadend = function() {
                            base64data = reader.result;            
                            context.commit("SET_PDF", base64data)
                            context.commit("SET_OPEN_ALERT", true);
                            context.commit("SET_ALERT", { status: 'success', text: "PDF cargado con éxito" });
                        }
                    } catch (error) {
                        context.commit("SET_LOADING", false);
                        context.commit("SET_PDF", `data:application/pdf;pdf;base64,null`)
                        context.commit("SET_OPEN_ALERT", true);
                        context.commit("SET_ALERT", { status: 'error', text: "El archivo pdf es muy pesado." });
                        context.commit("SET_ERROR", error);
                    }
                })
                .catch((err) => {
                    context.commit("SET_LOADING", false);
                    context.commit("SET_PDF", `data:application/pdf;pdf;base64,null`)
                    context.commit("SET_OPEN_ALERT", true);
                    context.commit("SET_ALERT", { status: 'error', text: "Hay problemas para cargar el PDF." });
                    context.commit("SET_ERROR", err);
                })
        },
        resetPdf(context: any, payload: IPdf){
            context.commit("PDF_ZOOM", 100);
            context.commit("OPEN_SURVEYS", false);
            context.commit("LOADED_PDF", false);
            // context.commit("SET_PDF", '');
            context.commit("SET_ALERT", {
                status: '',
                text: ''
            });
            context.commit("SET_OPEN_ALERT", false);

        }
    },
    getters: {
        getZoom(state: IState) {
            return state.zoom;
        },
        getOpenSurveys(state: IState) {
            return state.openSurveys;
        },
        getLoadedPdf(state: IState) {
            return state.loadedPdf;
        },
        getPdf(state: IState) {
            return state.pdf;
        }
    }
}